"use client";

import { useEffect, useState } from "react";

/**
 * Hook compartido para leer el estado de impersonación.
 *
 * Cuando admin clickea "Ver como X" en /admin/usuarios, se guarda info en
 * sessionStorage con esta forma:
 *
 *   { userId, nombre, role, roles: string[], perfiles?: string[] }
 *
 * Este hook lo expone de forma reactiva (se setea en useEffect después de
 * mount) para que cualquier componente (UserMenu, UserAvatar, banner, etc.)
 * pueda mostrar la info del usuario impersonado en lugar de la del admin.
 *
 * SSR seguro: durante el render del servidor y el primer render del cliente
 * devuelve null (consistente con el HTML del server) — se actualiza después
 * del primer effect. Sin hydration mismatch.
 */
export type ImpersonateState = {
  userId: string;
  nombre: string;
  role?: string;
  roles?: string[];
  perfiles?: string[]; // alias legacy
};

export function useImpersonate(): ImpersonateState | null {
  const [impersonate, setImpersonate] = useState<ImpersonateState | null>(null);

  useEffect(() => {
    try {
      const raw =
        typeof window !== "undefined"
          ? sessionStorage.getItem("cacique_impersonate")
          : null;
      if (raw) {
        const parsed = JSON.parse(raw) as ImpersonateState;
        if (parsed?.userId) setImpersonate(parsed);
      }
    } catch {
      /* ignore */
    }
  }, []);

  return impersonate;
}
